<template>
  <div class="bgGra articleContent">
    <div class="header">
      <div>
        <h2>{{ title }}</h2>
        <div class="headerTop">
          <div>
            <span style="margin-right:120px;">{{ promoteBusiness }}</span>
            <span>阅读量：{{ pcReadNum }}</span>
          </div>

          <div>
            <span @click="collectClickFun">
              <van-icon :name="starName" color="#333333" v-if="!LikeBt"/>
              <van-icon name="star" color="#E66104" v-else/>
              {{ pcCollectNum }}
            </span>
            <span @click="ToClick">
              <van-icon name="good-job-o" color="#333333" v-if="!actionBt"/>
              <van-icon name="good-job" color="#E66104" v-else/>
              {{ pcLikeNum }}
            </span>
          </div>
          <!--<div></div>-->
        </div>
      </div>

    </div>
    <div>
      <div class="articleImg">
        <img :src="pcMainImage" width="100%">
      </div>
    </div>

  </div>
</template>

<script>
import {Toast} from 'mint-ui';
import {Resource} from '@/services/resource';
import {Popup} from 'mint-ui';
import {Icon} from 'vant';
import Vue from "vue";
Vue.component(Popup.name, Popup);
Vue.use(Icon);
export default {
  components: {
  },
  props: {},
  created() {

  },
  mounted() {
    // document.body.style.backgroundColor = "#EFEFF1";
    this.id = this.$route.query.id;
    this.getDetail();
    this.toRead();
  },

  data() {
    return {
      contentType:"",
      title: "",
      promoteBusiness: "",
      recordlist: false,
      recordData: {},
      dialogWhetherShow: false,
      action: 0, //0取消收藏，1收藏
      actionBt: false, //收藏
      LikeNM: 0, //
      LikeBt: false, //点赞
      showF: false,
      mainCompany: "丞乐科技有限公司",//主体公司
      pcCollectNum: "1", //收藏量
      pcLikeNum: "2", //网站点赞量
      pcReadNum: "3", //网站阅读量
      id: "",
      pcMainImage: "",
      content: "",
      starName: 'star-o'


    };
  },
  methods: {


    // 跳转页面
    pageTo(name) {
      this.$router.push(name);

    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    getDetail() {
      Resource.promotionDetail.post({}, {
        // action: 1,
        id: this.id,
        platform: 1
      }).then(res => {
        this.contentType = res.data.contentType
        this.title = res.data.title;
        this.promoteBusiness = res.data.promoteBusiness;
        this.pcMainImage = res.data.pcMainImage;
        this.mainCompany = res.data.mainCompany;
        this.pcCollectNum = res.data.pcCollectNum;
        this.pcLikeNum = res.data.pcLikeNum;
        this.pcReadNum = res.data.pcReadNum;
        this.id = res.data.id;
        this.content = res.data.content;

      })
    },
    toRead() {
      Resource.promotionRead.post({}, {
        // action: 1,
        id: this.id,
        platform: 1
      }).then(res => {

        this.getDetail();

      })
    },
    collectClickFun() {
      const p = document.getElementsByClassName('van-icon');
      // this.LikeBt = !this.LikeBt;
      this.LikeBt = true;
      if (this.LikeBt) {
        this.LikeNM = 1
      } else {
        this.LikeNM = 0
      }

      Resource.collectClick.post({}, {
        action: this.LikeNM,
        id: this.id,
        platform: 1
      }).then(res => {
        Toast({message: "点赞成功！", position: "middle"});
        this.getDetail();
      })
    },
    ToClick() {
      // this.actionBt = !this.actionBt;
      this.actionBt = true;
      if (this.actionBt) {
        this.action = 1
      } else {
        this.action = 0
      }
      Resource.likeClick.post({}, {
        action: this.action,
        id: this.id,
        platform: 1
      }).then(res => {
        Toast({message: "收藏成功！", position: "middle"});
        this.getDetail();

      })


    },

  }
};
</script>
<style lang="less" scoped>
boby {
  background: #fff;
}

.articleContent {
  width: 100%;
  margin: 0 auto;
  padding: 0 250px
}

.header {
  h2 {
    text-align: left;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    font-size: 50px;
    margin-top: 80px;
  }

  .headerTop {
    height: 30px;
    line-height: 30px;
    margin: 60px 0;
    font-size: 20px;

    div {
      display: inline-block;
    }
  }

}

.headerTop div:nth-of-type(2) {
  float: right;
}

.articleImg {
  margin: 46px 0;
  width: 100%;
}
</style>
